import { CloseOutlined } from "@ant-design/icons";
import { Checkbox, Dropdown } from "antd";
import { useEffect, useState } from "react";

const SingleFilter = ({ field, onChange, values, autoOpen }) => {
  const [open, setOpen] = useState(autoOpen);

  useEffect(() => {
    if (autoOpen) {
      setOpen(true);
    }
  }, [autoOpen]);

  const items = [
    { name: "Yes", id: true },
    { name: "No", id: false },
    { name: "Empty", id: null },
  ];

  const getDropdownItem = (key, item) => ({
    key,
    label: (
      <div
        key={key}
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => onChange(field.id, item.id)}
        role="presentation"
      >
        <Checkbox checked={values.includes(item.id)} />
        <span style={{ marginLeft: 10 }}>{item.name}</span>
      </div>
    ),
  });

  const filters = () => items.map((item, index) => getDropdownItem(index, item));

  const generateTagString = () => {
    if (!values.length) return "";

    let string = "";

    for (let i = 0; i < values.length && i < 3; i += 1) {
      const selected = items.find((element) => element.id === values[i]);
      const name = selected?.name || "";

      if (i !== 2) {
        string = i ? `${string}, ${name}` : name;
      } else {
        string = `${string}, ${values.length - 2} more`;
      }
    }

    return string;
  };

  return (
    <Dropdown
      menu={{ items: filters(), onClick: (e) => e.preventDefault() }}
      trigger={["click"]}
      styles={{ root: { boxShadow: "0px 20px 140px 0px rgba(0, 0, 0, 0.15)" } }}
      open={open}
      onOpenChange={setOpen}
    >
      <div
        onClick={() => setOpen(true)}
        role="presentation"
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "#FFFFFF",
          border: "1px solid #6C6C8929",
          borderRadius: 8,
          padding: "5px 10px",
          fontSize: 14,
          cursor: "pointer",
          maxWidth: "100%",
        }}
      >
        <span style={{ fontWeight: 600 }}>{field.name}: </span>

        <span
          style={{
            color: "rgba(108, 108, 137, 1)",
            marginLeft: 4,
            whiteSpace: "nowrap",
          }}
        >
          {generateTagString()}
        </span>

        <div
          style={{
            width: 1,
            height: 16,
            background: "#6C6C89",
            opacity: 0.3,
            borderRadius: 1,
            marginLeft: 8,
            marginRight: 8,
            flexShrink: 0,
          }}
        />

        <span
          style={{
            cursor: "pointer",
            color: "rgba(178, 178, 199, 1)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          onClick={(e) => {
            e.stopPropagation();
            onChange(field.id);
          }}
          role="presentation"
        >
          <CloseOutlined style={{ fontSize: 12 }} />
        </span>
      </div>
    </Dropdown>
  );
};

export default SingleFilter;